import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { Button, Row, Col, Checkbox, Form } from "antd";
import { Input } from "../../Common/Input/index";
import { RequiredFormLabel } from "../RequiredFormLabel/RequiredFormLabel";
import BillingMethodSelect from "../BillingMethodSelect/BillingMethodSelect";
import BillingTimelineSelect from "../BillingTimelineSelect/BillingTimelineSelect";
import { BILLING_METHOD } from "../../../utils/onboarding-helper";

const commonBillingFields = [
  "address_line_1",
  "address_line_2",
  "city",
  "state",
  "country",
  "zip_code",
];

const BillingDetailsForm = (props) => {
  const {
    control,
    errors,
    setValue,
    getValues,
    watch,
    // getCustomerDetailsValues,
    // resetField,
    clearErrors,
  } = props;

  const billingMethod = watch("billing_method");
  const sameBillingAddress = watch("same_billing_address");

  const billingAddressOnCheck = (e) => {
    for (const field of commonBillingFields) {
      if (e.target.checked) {
        clearErrors(`billing_details.${field}`);
        setValue(`billing_details.${field}`, getValues(field));
      } else {
        setValue(`billing_details.${field}`, "");
      }
    }
  };

  return (
    <div className="onboarding-billing-details-form">
      <Form layout="vertical">
        <Row gutter={8}>
          {/* Billing details Col1 */}
          <Col
            span={8}
            offset={billingMethod === BILLING_METHOD.CORPORATE ? 0 : 8}
          >
            <Form.Item
              label={<RequiredFormLabel value="Billing Method" />}
              help={errors?.billing_method?.message}
              validateStatus={errors?.billing_method ? "error" : ""}
            >
              <Controller
                control={control}
                name="billing_method"
                render={({ field: { onChange, value } }) => (
                  <BillingMethodSelect value={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Billing Timeline" />}
              help={errors?.billing_timeline?.message}
              validateStatus={errors?.billing_timeline ? "error" : ""}
            >
              <Controller
                control={control}
                name="billing_timeline"
                render={({ field: { onChange, value } }) => (
                  <BillingTimelineSelect value={value} onChange={onChange} />
                )}
              />
            </Form.Item>
          </Col>
          {billingMethod === BILLING_METHOD.CORPORATE ? (
            <>
              {/* Billing details Col 2 */}
              <Col span={8}>
                <Form.Item>
                  <Controller
                    control={control}
                    name="same_billing_address"
                    render={({ field: { onChange, value } }) => (
                      <Checkbox
                        onChange={(e) => {
                          billingAddressOnCheck(e);
                          onChange(e);
                        }}
                        checked={value}
                      >
                        The Billing Address is the same as Customer's Address
                      </Checkbox>
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={<RequiredFormLabel value="Address Line 1" />}
                  help={errors?.billing_details?.address_line_1?.message}
                  validateStatus={
                    errors?.billing_details?.address_line_1 ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="billing_details.address_line_1"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={sameBillingAddress}
                        placeholder="Address Line 1"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={<RequiredFormLabel value="Address Line 2" />}
                  help={errors?.billing_details?.address_line_2?.message}
                  validateStatus={
                    errors?.billing_details?.address_line_2 ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="billing_details.address_line_2"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={sameBillingAddress}
                        placeholder="Address Line 2"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={<RequiredFormLabel value="City" />}
                  help={errors?.billing_details?.city?.message}
                  validateStatus={errors?.billing_details?.city ? "error" : ""}
                >
                  <Controller
                    control={control}
                    name="billing_details.city"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={sameBillingAddress}
                        placeholder="City"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={<RequiredFormLabel value="State" />}
                  help={errors?.billing_details?.state?.message}
                  validateStatus={errors?.billing_details?.state ? "error" : ""}
                >
                  <Controller
                    control={control}
                    name="billing_details.state"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={sameBillingAddress}
                        placeholder="State"
                      />
                    )}
                  />
                </Form.Item>
              </Col>
              {/* Billing Details Col 3 */}
              <Col span={8}>
                <Form.Item
                  label={<RequiredFormLabel value="Country" />}
                  help={errors?.billing_details?.country?.message}
                  validateStatus={
                    errors?.billing_details?.country ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="billing_details.country"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={sameBillingAddress}
                        placeholder="Country"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={<RequiredFormLabel value="Zip Code" />}
                  help={errors?.billing_details?.zip_code?.message}
                  validateStatus={
                    errors?.billing_details?.zip_code ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="billing_details.zip_code"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={sameBillingAddress}
                        placeholder="Zip Code"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={<RequiredFormLabel value="Billing Contact Name" />}
                  help={errors?.billing_details?.name?.message}
                  validateStatus={errors?.billing_details?.name ? "error" : ""}
                >
                  <Controller
                    control={control}
                    name="billing_details.name"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        placeholder="Billing Contact Name"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <RequiredFormLabel value="Billing Contact Phone Number" />
                  }
                  help={errors?.billing_details?.phone_number?.message}
                  validateStatus={
                    errors?.billing_details?.phone_number ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="billing_details.phone_number"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        placeholder="Billing Contact Phone Number"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={<RequiredFormLabel value="Billing Contact Email" />}
                  help={errors?.billing_details?.email?.message}
                  validateStatus={errors?.billing_details?.email ? "error" : ""}
                >
                  <Controller
                    control={control}
                    name="billing_details.email"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        placeholder="Billing Contact Email"
                      />
                    )}
                  />
                </Form.Item>
              </Col>
            </>
          ) : null}
        </Row>
      </Form>
    </div>
  );
};

export default BillingDetailsForm;
